import { ThemeProvider as StyledThemeProvider } from 'styled-components'
import { StyledEngineProvider, ThemeProvider as MuiThemeProvider } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'

import { WithChild } from 'utils'
import GlobalCss from 'styles/globalStyles/GlobalCss'
import ResetCss from 'styles/globalStyles/ResetCss'
import theme from 'styles/theme'

type StyleProviderProps = {} & WithChild

export default function StylesProvider({ children }: StyleProviderProps) {
  return (
    <StyledEngineProvider injectFirst>
      <MuiThemeProvider theme={theme}>
        <StyledThemeProvider theme={theme}>
          <GlobalCss />
          <ResetCss />
          <CssBaseline />
          {children}
        </StyledThemeProvider>
      </MuiThemeProvider>
    </StyledEngineProvider>
  )
}
